export const FETCH_SERVICES = 'FETCH_SERVICES';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_ERROR = 'FETCH_SERVICES_ERROR';
export const NON_UAE_VALIDATION_ERROR = 'NON_UAE_VALIDATION_ERROR';
export const SAVE_SLUG_NAME = 'SAVE_SLUG_NAME';
